import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})

export class ModalWidget {
    @Input() heading:string;
    @ViewChild('lgModal') modalDom: BsModalRef;
    private _open;

    @Input()
    set open(val: boolean) {
        this._open = val
        if(this._open){
        }
    }

    get open(): boolean { return this._open; }

    hideModal() {
      return this.modalDom.hide();
    }
}
